import React, { createContext, useContext, ReactNode } from 'react';
import { useResponsive, DeviceType } from '@/hooks/useResponsive';

interface ResponsiveContextType {
  width: number;
  height: number;
  device: DeviceType;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isLandscape: boolean;
  isPortrait: boolean;
  isIphoneSE: boolean;
  isIphoneXR: boolean;
  isIphone12: boolean;
  isIphone14ProMax: boolean;
  isSamsungGalaxy: boolean;
}

const ResponsiveContext = createContext<ResponsiveContextType | undefined>(undefined);

interface ResponsiveProviderProps {
  children: ReactNode;
}

/**
 * Provider component để cung cấp context cho responsive
 */
export const ResponsiveProvider: React.FC<ResponsiveProviderProps> = ({ children }) => {
  const responsive = useResponsive();

  return (
    <ResponsiveContext.Provider value={responsive}>
      {children}
    </ResponsiveContext.Provider>
  );
};

/**
 * Hook để sử dụng responsive context
 */
export const useResponsiveContext = (): ResponsiveContextType => {
  const context = useContext(ResponsiveContext);
  
  if (context === undefined) {
    throw new Error('useResponsiveContext must be used within a ResponsiveProvider');
  }
  
  return context;
};
